<template>
  <slot :name="target"></slot>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';
import { AnalyticsCookies, TestOptionType, useABTesting } from '../../composables/ab-testing.composable';
import { waitForUserInteraction } from '../../composables/analytics-ow.composable';

export default defineComponent({
  name: 'TestingGenericWrapper',
  props: {
    /**
     * Local storage key to get value that can be <target | target A | target B | control>
     * control is for default option
     */
    storageKey: {
      type: String,
      required: true,
    },
  },
  emits: ['test-option-set'],
  setup(props, { emit }) {
    const { key, target, setTarget, reset, enableLocaleStorageUsage } = useABTesting(props.storageKey);

    onMounted(async () => {
      if (target.value) {
        emit('test-option-set', target.value);
      } else {
        try {
          await waitForUserInteraction().catch((error) => {
            throw new Error(error);
          });

          const consents = localStorage.getItem(AnalyticsCookies.CMPConsents);
          const cookies = consents ? JSON.parse(consents) : consents;
          const cookiesAccepted =
            cookies && cookies[AnalyticsCookies.AdobeTarget] && cookies[AnalyticsCookies.ABTesting];

          if (cookiesAccepted) {
            enableLocaleStorageUsage();

            let counter = 0;
            const interval = setInterval(() => {
              if (localStorage.getItem(key)) {
                setTarget(localStorage.getItem(key) as TestOptionType);
                emit('test-option-set', target.value);
                clearInterval(interval);
              } else if (++counter > 20) {
                // if analytics don't set up the localStorage with a value
                if (!target.value) {
                  reset();
                  clearInterval(interval);
                }
              }
            }, 250);
          } else {
            reset();
          }
        } catch {
          reset();
        }
      }
    });

    return {
      target,
    };
  },
});
</script>
